export const CONFIRM_PAGE_DELETE_TEXT =
  'Are you sure you want to delete this dialogue?';
export const CONFIRM_PAGE_DELETE_WIDGET =
  'Are you sure you want to delete this widget?';
